/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Funkce`
};

const da_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Karakteristisk`
};

const de_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Merkmal`
};

const en_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Characteristic`
};

const es_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Características del producto`
};

const fr_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Caractéristique`
};

const hu_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Jellegzetes`
};

const it_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Caratteristica`
};

const nl_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Karakteristiek`
};

const pl_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Charakterystyka`
};

const pt_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Característica`
};

const sv_attributes_apparel_type = /** @type {(inputs: {}) => string} */ () => {
	return `Egenskaper`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_apparel_type = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_apparel_type(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_apparel_type", locale)
	if (locale === "cs") return cs_attributes_apparel_type(inputs)
	if (locale === "da") return da_attributes_apparel_type(inputs)
	if (locale === "de") return de_attributes_apparel_type(inputs)
	if (locale === "en") return en_attributes_apparel_type(inputs)
	if (locale === "es") return es_attributes_apparel_type(inputs)
	if (locale === "fr") return fr_attributes_apparel_type(inputs)
	if (locale === "hu") return hu_attributes_apparel_type(inputs)
	if (locale === "it") return it_attributes_apparel_type(inputs)
	if (locale === "nl") return nl_attributes_apparel_type(inputs)
	if (locale === "pl") return pl_attributes_apparel_type(inputs)
	if (locale === "pt") return pt_attributes_apparel_type(inputs)
	return sv_attributes_apparel_type(inputs)
};
export { attributes_apparel_type as "attributes.apparel_type" }